import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    height: "100%",
  },
  item: {
    width: "600px",
  },
}));
